/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getFile, showModal } from "actions";
import GuidebarModalBody, {
  GuidebarModalTitle,
} from "components/header/GuidebarModal";

class OrganisationChartCard extends Component {
  state = {
    fileFetched: false,
    file: null,
    error: null,
  };

  componentDidMount = () => {
    // console.log(this.props);
    if (this.props.contact.imagePath) {
      this.props.getFile(
        this.props.contact.imagePath,
        this.onBegin,
        this.onSuccess,
        this.onError
      );
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
  };

  onSuccess = (file) => {
    this.props.onProcessEnd();
    this.setState({
      fileFetched: true,
      file: file,
    });
  };

  showDetail = (contact) => {
    this.props.showModal({
      modalType: "GuideDetail",
      modalTitle: <GuidebarModalTitle />,
      modalContent: <GuidebarModalBody id={contact.id} />,
      modalFooter: null,
      modalElementId: "guideModal",
    });
  };

  renderImage = () => {
    return (
      <div className="fordOrgSchemaProfilImgArea">
        <div
          className="fordOrgSchemaProfilImg"
          style={{
            backgroundImage: `url(${this.state.file
              ? this.state.file.binary
              : "img/ford-gelisim-akademisi-avatar.svg"
              })`,
          }}
        ></div>
      </div>
    );
  };

  renderEmail = () => {
    if (!this.props.contact.email) return null;
    return (
      <li>
        <a href="mailto:okocgibiuzun@ford.com.tr">
          <span className="icon-icon-mail"></span> {this.props.contact.email}
        </a>
      </li>
    );
  };

  renderCompanyPhone = () => {
    if (!this.props.contact.companyPhone) return null;
    return (
      <li>
        <a href={`tel:${this.props.contact.companyPhone}`}>
          <span className="iconmford fo-icon-phone"></span>{" "}
          {this.props.contact.companyPhone}
        </a>
      </li>
    );
  };

  render() {
    return (
      <div className="fordOrgSchemaInner">
        <a href="#" onClick={() => this.showDetail(this.props.contact)}>
          {this.renderImage()}
          <div className="fordOrgSchemaProfilTextArea text-center">
            <div className="fordOrgSchemaName">
              {this.props.contact.fullname}
            </div>
            <div className="fordOrgSchemaTitle">
              {this.props.contact.position}
            </div>
          </div>
        </a>
        <div className="fordOrgSchemaDownMenu">
          {this.props.hasChildren ? (
            <a onClick={this.props.onSelect}>
              <span className="iconmford fo-icon-add"></span>
            </a>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connect(null, { getFile, showModal })(
  containsLongRunningProcess(OrganisationChartCard)
);
